import * as THREE from 'three';
import { $ } from '../state/store.js';


/* ═══════════════════════════════════════════════════════════
   THREE  ·  scene, lights, helpers
   ═══════════════════════════════════════════════════════════ */
export const canvas = $('#cv');
export const renderer = new THREE.WebGLRenderer({canvas, antialias:true, alpha:true, preserveDrawingBuffer:true});
renderer.setPixelRatio(Math.min(devicePixelRatio,2));
renderer.shadowMap.enabled = true;
/* PCFShadowMap, not PCFSoftShadowMap: PCFSoftShadowMap's "soft" is a fixed
   single-texel 3x3 tap, hardcoded in its shader chunk, completely blind to
   shadow.radius — Shadow blur (Settings → scene/lighting.js's setShadowSoft)
   would do nothing under it. VSMShadowMap does read radius, but its
   variance-based softening leaks light ("bleeding") at sharp geometry
   discontinuities — visibly, at a recess's own internal corners, which are
   exactly the kind of shadow this app draws most. Plain PCFShadowMap reads
   shadow.radius too (it scales a 17-tap sample spread) without that
   statistical bleed — a plain blurred depth comparison, nothing to leak. */
renderer.shadowMap.type = THREE.PCFShadowMap;
renderer.shadowMap.autoUpdate = true;
renderer.outputColorSpace = THREE.SRGBColorSpace;
export const TONE = {
  none:  THREE.NoToneMapping,
  agx:   THREE.AgXToneMapping ?? THREE.ACESFilmicToneMapping,
  aces:  THREE.ACESFilmicToneMapping,
  cineon:THREE.CineonToneMapping,
  reinhard: THREE.ReinhardToneMapping
};
renderer.toneMapping = TONE.none;

export const scene = new THREE.Scene();
export const content = new THREE.Group();    // user objects only
export const helpers = new THREE.Group();    // screen frame, frustum, eye, grid
/* THE BEZELS between an array's screens — deliberately NOT helpers.

   A helper is a workspace aid that never reaches the deliverable, which is why
   beginFrames hides the whole group and why the Settings toggle can turn it
   off. A bezel is neither: it is a physical part of the installation, so it has
   to be visible in every view whatever that toggle says, and turning it off
   would misrepresent the wall rather than declutter it.

   It also does not need hiding for the export, and that is the point: each
   screen is rendered through a frustum that is exactly its own rectangle, and
   the bezels lie in the gaps BETWEEN those rectangles, so no tile's camera can
   see one. If a bezel ever did show up in an exported file it would mean the
   per-screen frustum had drifted off the screen it belongs to — so leaving them
   in the scene makes the export check itself. */
export const bezels = new THREE.Group();
scene.add(content, helpers, bezels);

export const orbitCam = new THREE.PerspectiveCamera(38, 1, 0.05, 3000);
export const flatCam  = new THREE.PerspectiveCamera(45, 1, 0.05, 3000);
/* The second panel of a corner screen. Identical construction to flatCam —
   both have their projection replaced wholesale by scene/cameras.js's
   updateScreenCam, so the constructor arguments only ever matter before the
   first frame. Unused, and costing nothing, while S.cornerPanel is null. */
export const cornerCam = new THREE.PerspectiveCamera(45, 1, 0.05, 3000);
